var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c("v-text-field", {
        attrs: {
          disabled: _vm.isDefaultValue,
          "error-messages": _vm.errorMessages,
          hint: _vm.hint,
          label: _vm.label,
          prefix: _vm.prefix,
          rules: _vm.contextRules,
          suffix: _vm.suffix,
          type: _vm.contextType
        },
        model: {
          value: _vm.contextModel,
          callback: function($$v) {
            _vm.contextModel = $$v
          },
          expression: "contextModel"
        }
      }),
      _c("v-checkbox", {
        attrs: {
          slot: "activator",
          disabled: _vm.checkboxDisabled,
          label: _vm.checkboxText,
          bottom: ""
        },
        slot: "activator",
        model: {
          value: _vm.isDefaultValue,
          callback: function($$v) {
            _vm.isDefaultValue = $$v
          },
          expression: "isDefaultValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }